"use strict";
/* istanbul ignore else */
if (HTMLElement.prototype.checkVisibility === undefined) {
    HTMLElement.prototype.checkVisibility = function checkVisibility() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        for (let el = this; el !== null; el = el.parentElement) {
            const style = getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden' || el.getAttribute('hidden') !== null || el.hidden === true) {
                return false;
            }
        }
        return true;
    };
}
//# sourceMappingURL=CheckVisibility.js.map